import { useMutation } from "@tanstack/react-query";
import { resvsApi } from "components/api/mypage";
import { IResv, resvProps } from "interface/mypage";
import { useEffect, useRef, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { successControl } from "util/commAction";
import MyBook from "components/view/mypage/book";
import { IOutletContext } from "components/view/mypage/book/layout";

export default function MyBookPage() {
  const { resvStat } = useOutletContext<IOutletContext>();

  const [resvs, setResvs] = useState<IResv[]>([]);
  const pageNav = useRef(null);

  //예약리스트 조회
  const resvsMutation = useMutation({
    mutationFn: resvsApi,
    onSuccess: (res) => {
      if (res) {
        successControl({
          status: res.status,
          success: () => {
            pageNav.current = res.data.pageNav;
            setResvs(res.data.resvList);
          },
        });
      }
    },
  });

  useEffect(() => {
    if (resvStat) {
      const params: resvProps = {
        resvStat: resvStat,
        pageNo: 1,
        pageRows: 10,
      };

      resvsMutation.mutate(params);
    }
  }, [resvStat]);

  return <MyBook resvs={resvs} />;
}
